// /billing/success — исторический адрес «спасибо за покупку».
//
// После переезда продажи в IEC ID экрана успеха не существует: возврат из их
// витрины не несёт ни токена заказа, ни признака оплаты (гайд §4.5 шаг 3), и
// рисовать успех «на веру» — ровно та ошибка, от которой предостерегает гайд.
// Единственный честный экран — «проверяем оплату» с опросом прав, и он один:
// `/settings/billing?iec=return`. Адрес возврата сервер собирает туда же
// (`modules/iec-id/mutations/handoff.ts`).
//
// Сам маршрут оставлен живым, а не удалён: на него ведут письма и закладки,
// выданные до переезда, — они должны приводить к состоянию, а не в 404.

import { createFileRoute, redirect } from "@tanstack/react-router";
import { IEC_RETURN_FLAG } from "@/components/billing/_use-iec-checkout";
import { isCommerceVisible } from "@/lib/module-availability/commerce";

export const Route = createFileRoute("/billing/success")({
	beforeLoad: () => {
		// Возврат из оплаты при выключенной коммерции — состояние, которого не
		// бывает; но ссылка из старого письма прийти может. Уводим на главную,
		// а не на `/settings/billing`: тот роут сейчас тоже закрыт.
		if (!isCommerceVisible()) throw redirect({ to: "/" });
		throw redirect({
			to: "/settings/billing",
			search: { iec: IEC_RETURN_FLAG },
			replace: true,
		});
	},
});
